import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as yup from 'yup';

import firebase from '@chronos/firebase';
import { COLORS, PRIMARY_COLOR } from '@chronos/constants';

import { Button, Text, Spacer } from '../../components';
import { useBus } from '../../state';
import { FormInput } from '../../components/Fom';

interface FormValues {
  email: string;
}

const formSchema = yup.object().shape({
  email: yup.string().trim().email('Must be a valid email').required('Required')
    .min(1),
});

export default function ForgotPassword() {
  const { banner } = useBus();
  const { push } = useHistory();

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ email }: FormValues) => {
    setIsLoading(true);

    try {
      await firebase.auth.sendPasswordResetEmail(email);
      banner({
        message: 'An email has been sent to your inbox to reset your password',
      });
      push('/login');
    } catch (err) {
      setError(err.message);
    }

    setIsLoading(false);
  };

  return (
    <Formik<FormValues>
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={formSchema}
      initialValues={{
        email: '',
      }}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form>
          <Text as="h1" semibold color={PRIMARY_COLOR} center>Forgot Password</Text>
          <Spacer />
          {error && <Text color={COLORS.RED}>{error}</Text>}
          <Spacer />
          <Text as="h3" center>
            Enter your email below, and we'll send you a recovery email to reset your password.
          </Text>
          <Spacer size={20} />

          <FormInput name="email" label="Email" />
          <Spacer />
          <Button
            width="100%"
            primary
            type="submit"
            loading={isLoading}
            onClick={() => undefined}
          >
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
}
